import React from "react";
import PropTypes from "prop-types";
import Tippy from "@tippy.js/react";

const Tooltip = props => {
  const { text } = props;
  return (
    <Tippy
      interactive
      content={<span dangerouslySetInnerHTML={{ __html: text }} />}
      trigger="click"
      arrow="true"
    >
      <i className="icon-question tooltip-icon" />
    </Tippy>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired
};

export default Tooltip;
